import React, { ReactNode } from 'react';
import cn from 'classnames';

import { TabView, TabPanel } from 'primereact/tabview';

import './style.scss';

type TMainTabViewProps = {
  activeIndex: number;
  setActiveIndex: (number: number) => void;
  tabsContent: {
    title: string;
    id?: string;
    content?: ReactNode;
  }[];
  tableView?: boolean;
  className?: string;
};

export const MainTabView = ({
  activeIndex,
  setActiveIndex,
  tabsContent,
  tableView,
  className,
}: TMainTabViewProps): JSX.Element => (
  <div className={cn(className, 'tab-view-container table-view')}>
    <TabView
      renderActiveOnly={false}
      activeIndex={activeIndex}
      onTabChange={(e) => setActiveIndex(e.index)}
    >
      {tabsContent.map((item) => (
        <TabPanel key={item.id ?? item.title} header={item.title}>
          {item.content}
        </TabPanel>
      ))}
    </TabView>
  </div>
);

MainTabView.defaultProps = {
  tableView: false,
};
